import AccountCard from '@atoms/AccountCard';
import ShimmerAccountList from '@atoms/Shimmers/ShimmerAccountList';
import SkeletonComponent from '@atoms/SkeletonComponent';
import { getStore } from '@store/storeUtils';
import React, { useMemo } from 'react';
import { FlatList, StyleProp, ViewStyle } from 'react-native';
import styles from './styles';

// Define the Account type
type Account = {
  id: number | string;
  // Add other fields of the account object if needed
};

// Define the component props
type AccountListProps = {
  isLoading?: boolean;
};

const AccountList: React.FC<AccountListProps> = ({ isLoading = false }) => {
  const { accounts }: { accounts?: Account[] } = getStore();

  const memoizedAccounts = useMemo(() => accounts || [], [accounts]);

  if (isLoading) {
    return <ShimmerAccountList />;
  }

  if (memoizedAccounts.length > 0) {
    return (
      <FlatList
        testID="LstAccounts"
        sentry-label="LstAccounts"
        contentContainerStyle={styles.flatListParent as StyleProp<ViewStyle>}
        data={memoizedAccounts}
        horizontal
        showsHorizontalScrollIndicator={false}
        keyExtractor={item => item?.id?.toString()}
        renderItem={({ item }) => <AccountCard account={item} />}
      />
    );
  }

  return <SkeletonComponent />;
};

export default React.memo(AccountList);
